import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import Landing from './pages/Landing';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import AddProperty from './pages/AddProperty';
import AuthCallback from './pages/AuthCallback';
import Login from './pages/Login';
import Register from './pages/Register';
import EMICalculator from './pages/EMICalculator';
import UserTypeSelection from './pages/UserTypeSelection';
import NewLaunches from './pages/NewLaunches';
import AboutUs from './pages/AboutUs';
import ProtectedRoute from './components/ProtectedRoute';
import InstallPrompt from './components/InstallPrompt';
import { Toaster } from './components/ui/sonner';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/properties/:propertyId" element={<PropertyDetail />} />
        <Route path="/new-launches" element={<NewLaunches />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/calculator" element={<EMICalculator />} />
        <Route path="/user-type-selection" element={<UserTypeSelection />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-property"
          element={
            <ProtectedRoute>
              <AddProperty />
            </ProtectedRoute>
          }
        />
      </Routes>
      <InstallPrompt />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;